export default {
  navBar: {
    project:"Projet : {project}",
    disconnect:"Déconnexion",
    language: {
      title: "Changer la langue",
      en: "Anglais",
      fr: "Français",
    }
  },
  menu: {
    dashboard: "Tableau de bord",
    projects: "Projets",
    projectsSettings: "Paramètres",
    projectsUsers: "Utilisateurs",
    projectsAgences: "Agences",
    projectsLocalities: "Localités",
    forms: "Questionnaires",
    customers: "Clients",
    customerDoubles: "Clients doubles",
    map: "Carte",
    reporting: "Reporting",
    payments: "Paiements",
    users: "Utilisateurs",
    logs: "Logs",
    tables: "Accès base de données",
    settings: "Paramètres",
    mapElligibility: "Éligibilité carte",
  },
}
